<template>
	<div class="bg-black-gray3">
		<slot />
	</div>
</template>

<script>
export default {
	data() {
		return {}
	}
}
</script>

<style lang="scss" scoped>
.bg-black-gray3 {
	width: 100%;
	padding: 36px;
}
</style>
